import { render, staticRenderFns } from "./AchievementsWrapper.vue?vue&type=template&id=c2032d9c"
import script from "./AchievementsWrapper.vue?vue&type=script&lang=js"
export * from "./AchievementsWrapper.vue?vue&type=script&lang=js"
import style0 from "./AchievementsWrapper.vue?vue&type=style&index=0&id=c2032d9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports